import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { httpService } from "../httpService";
import { LoadingButton } from "@mui/lab";
import { AlertContext } from "../contexts/AlertContext";
import { LinearProgress } from "@mui/material";
import { AddAPhoto, Logout } from "@mui/icons-material";
import { Avatar, Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { storage } from "../firebase";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { Modal, ProgressBar } from "react-bootstrap";
import { faUser, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
function SinglePageRegistration() {
  const { setAlertData } = useContext(AlertContext);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [participant, setParticipant] = useState(null);
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const [image, setImage] = useState(null);
  const [progress, setProgress] = useState(0);

  const navigate = useNavigate();
  const getData = async () => {
    const { data, error } = await httpService(
      `retrieveindividualregistration/${id}`
    );

    if (data) {
      setParticipant(data);
    }

    if (error) {
      setAlertData({ open: true, message: error, severity: "error" });
    }
  };

  const updateRegistration = async () => {
    const { data, error } = await httpService.patch(
      `updateregistration/${id}`,
      participant
    );

    if (data) {
      setAlertData({ open: true, message: data, severity: "success" });
    }
    if (error) {
      setAlertData({ open: true, message: error, severity: "error" });
    }
  };
  useEffect(() => {
    getData();
  }, []);

  const handleChange = (e) => {
    setParticipant({ ...participant, [e.target.name]: e.target.value });
  };

  const toggle = () => setShow(!show);

  const handleFileChange = (e) => {
    if (e.target.files[0].size > 1_000_000)
      return setAlertData({
        message: "Please select an image less than or equal to 1MB.",
        open: true,
        severity: "error",
      });
    setFile(e.target.files[0]);

    setImage(URL.createObjectURL(e.target.files[0]));
  };

  const clearImage = () => {
    setFile(null);
    setImage(null);
  };

  const uploadImage = async (c) => {
    if (!file) return;
    setLoading(true);

    const extension = file.type.split("/").pop();
    const newFileName = `${c.code}.${extension}`;

    const storageRef = ref(storage, `/policymeeting/${newFileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        setProgress(prog);
      },
      (err) => {
        setAlertData({ open: true, message: err.message, severity: "error" });
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
          const imageURL = url;

          const { data, error } = await httpService.patch(
            `uploadimage/${c._id}`,
            { imageURL }
          );

          if (data) {
            window.location.reload();
          }

          if (error) {
            setAlertData({
              open: true,
              message: error,
              severity: "error",
            });
          }
        });
      }
    );

    setLoading(false);
  };

  return (
    <div>
      <div className="container mt-5">
        <div className="mb-5">
          <h4>Edit your registration</h4>
          {loading && (
            <div className="col-lg-4">
              <LinearProgress />
            </div>
          )}
        </div>
        {participant && (
          <div className="mb-4">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-4">
                  <label htmlFor="firstName" className="form-label">
                    First Name:
                  </label>
                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    className="form-control"
                    value={participant.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="lastName" className="form-label">
                    Last Name:
                  </label>
                  <input
                    onChange={handleChange}
                    id="lastName"
                    name="lastName"
                    type="text"
                    className="form-control"
                    value={participant.lastName}
                  />
                </div>{" "}
                <div className="mb-4">
                  <label htmlFor="emailAddress" className="form-label">
                    Email Address:
                  </label>
                  <input
                    onChange={handleChange}
                    id="emailAddress"
                    name="emailAddress"
                    type="text"
                    className="form-control"
                    value={participant.emailAddress}
                  />
                </div>{" "}
                <div className="mb-4">
                  <label htmlFor="phoneNumber" className="form-label">
                    Phone Number:
                  </label>
                  <input
                    onChange={handleChange}
                    id="phoneNumber"
                    name="phoneNumber"
                    type="text"
                    className="form-control"
                    value={`${participant.phoneNumber}`}
                  />
                </div>
                <div>
                  <LoadingButton
                    loading={loading}
                    onClick={updateRegistration}
                    variant="contained"
                  >
                    UPDATE REGISTRATION
                  </LoadingButton>
                </div>
              </div>
              <div className="col-lg-3">
                {participant.imageURL ? (
                  <>
                    <img
                      height={240}
                      width={240}
                      className="object-fit-fill "
                      //className="img-thumbnail"
                      src={participant.imageURL}
                      alt={participant.code}
                    />
                    <div>
                      <div className="mt-2">
                        <Button
                          endIcon={<AddAPhoto />}
                          onClick={() => {
                            //setParticipant(c);
                            setShow(true);
                          }}
                        >
                          Change image
                        </Button>
                        <div>
                          <Typography variant="caption">
                            Image should not be more than 1 MB
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div>
                    <Avatar variant="rounded" sx={{ height: 200, width: 220 }}>
                      <FontAwesomeIcon icon={faUser} />
                    </Avatar>
                    <div className="mt-2">
                      <Button
                        endIcon={<AddAPhoto />}
                        onClick={() => {
                          //setParticipant(c);
                          setShow(true);
                        }}
                      >
                        Upload image
                      </Button>
                      <div>
                        <Typography variant="caption">
                          Image should not be more than 1 MB
                        </Typography>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mt-5">
              <Button
                onClick={() =>
                  navigate(`/printout/${participant.institutionId}`)
                }
                color="error"
                endIcon={<Logout />}
                variant="contained"
              >
                print out slip
              </Button>
            </div>
          </div>
        )}
      </div>
      {participant && (
        <Modal centered size="xl" backdrop="static" show={show} onHide={toggle}>
          <Modal.Header closeButton>
            {participant.firstName}'s profile
          </Modal.Header>
          <Modal.Body>
            <div className="mb-2"></div>
            <div className="row">
              <div className="col-lg-6">
                <div class="mb-3">
                  <label for="formFile" class="form-label">
                    Select an image file
                  </label>
                  <input
                    class="form-control"
                    type="file"
                    id="formFile"
                    accept="image/png, image/gif, image/jpeg"
                    onChange={handleFileChange}
                  />
                </div>
                {progress > 0 && (
                  <ProgressBar now={progress} label={`${progress}%`} />
                )}
              </div>
              <div className="col-lg-6">
                {image && (
                  <div>
                    <img src={image} alt="question" className="img-thumbnail" />
                    <div className="mt-3">
                      <LoadingButton
                        endIcon={<FontAwesomeIcon icon={faFileUpload} />}
                        color="success"
                        onClick={() => uploadImage(participant)}
                        variant="contained"
                        loading={loading}
                        loadingPosition="end"
                      >
                        Upload image
                      </LoadingButton>
                      <Button color="error" onClick={clearImage}>
                        clear
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}

export default SinglePageRegistration;
